/**
 * App — the storefront shell: ambient particle backdrop, the routed page, and the
 * persistent bottom navigation. Theme is applied once via the global stylesheet
 * imported in {@link ./main}.
 */
import { Particles, useFirstPaintReflow } from "@melusine/shared-ui";
import { ThemeSync } from "@features/theme";
import { NavBar } from "@widgets/nav-bar";

import { AppRouter } from "./AppRouter";
import { ErrorBoundary } from "./ErrorBoundary";
import { Providers } from "./Providers";
import styles from "./App.module.css";

export function App(): JSX.Element {
  // Telegram/iOS webviews can report a 0-height viewport on the very first layout
  // pass, leaving the page blank until a resize forces a reflow. Nudge a synchronous
  // reflow on mount so content paints immediately, without waiting for a resize.
  useFirstPaintReflow();

  return (
    <ErrorBoundary>
      <Providers>
        <ThemeSync />
        <Particles />
        <div className={styles.shell}>
          <main className={styles.content}>
            <AppRouter />
          </main>
          <NavBar />
        </div>
      </Providers>
    </ErrorBoundary>
  );
}
